module.exports = __webpack_public_path__ + "img/yzbank.f18560b2.png";